import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { AppState } from '../reducers';
import { currentUser } from '../auth';
import { environment } from '../../../environments/environment';
import { HttpUtilsService } from '../_base/crud';

const API_BASE = environment.TIMELINE_BASE;

@Injectable()
export class TaskActionsService {
  private companyId;
  private myListSubject = new Subject<any>();
  reloadTaskActions = this.myListSubject.asObservable();
  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentUser)).subscribe((res) => (this.companyId = res.companyID));
  }
  updateList(newData: any) {
    this.myListSubject.next(newData);
  }
  getActionAdditionalStep(main_task_template_id) {
    return this.http.get<any>(
      `${API_BASE}/companies/${this.companyId}/actions-additional-steps?main_task_template_id=${main_task_template_id}`,
    );
  }

  postPutActionAdditionalStep(body) {
    return this.http.post<any>(
      `${API_BASE}/companies/${this.companyId}/actions-additional-steps`,
      body,
    );
  }

  deleteActionAdditionalStep(id) {
    return this.http.delete<any>(
      `${API_BASE}/companies/${this.companyId}/actions-additional-steps/${id}?id=${id}`,
    );
  }
}
